module.exports = __webpack_public_path__ + "static/media/NotoSansTC-Black-Alphabetic.26ecf737.woff2";